'use strict';

angular.module('shiftTraderApp')
  .factory('loginInterceptor', ['$injector', 'Session', '$location', '$rootScope', 'ServerUrls', 'RetryQueue', 'EventTrackingService', '$log', '$q',
    function ($injector, Session, $location, $rootScope, ServerUrls, RetryQueue, EventTrackingService, $log, $q) {
      var AUTHZ = 'Authorization';
      var OAuthKeys = $injector.get('OAuthKeys');

      var clearSession = function () {
        var $http = $injector.get('$http');
        $log.debug('loginInterceptor -> clearSession called');
        EventTrackingService.addEvent('login_interceptor_clear_session', { uuid: Session.getSessionId() });
        Session.clearSession();
        $rootScope.$broadcast('loginStateChanged', {state: false});
      };

      function isAnalyticsCaptureRequest(config) {
        return _.contains(config.url, ServerUrls.current.analyticsCaptureApi);
      }

      function isAuthRequired(config) {
        return !_.contains(config.url, 'oauth/token') &&
          !_.contains(config.url, 'keys') &&
          (_.contains(config.url, ServerUrls.current.railsApi.slice(0, -2)) || _.contains(config.url, ServerUrls.current.nodeApi.slice(0, -2))) &&
          !isAnalyticsCaptureRequest(config);
      }

      function shouldAttemptRecovery(originalResponse) {
        // should attempt to try again if we are UNAUTHORIZED (401)
        //    Meaning... the TOKEN was either not provided or has now expired and can be retried

        return originalResponse.status === 401 &&
          originalResponse.config && isAuthRequired(originalResponse.config);
      }

      function shouldAttemptTokenRefresh() {
        return !_.isNull(Session.getRefreshToken()) &&
          !_.isUndefined(Session.getRefreshToken()) &&
          Session.getRefreshToken() !== 'undefined';
      }

      function isAuthHeaderInvalid(config) {
        return _.contains(config.headers[AUTHZ], 'null') ||
          _.contains(config.headers[AUTHZ], 'undefined') ||
          (config.headers[AUTHZ] && config.headers[AUTHZ].length < 20);
      }


      return {
        request: function(config) {
          var toastr = $injector.get('toastr')

          if (isAuthRequired(config) && isAuthHeaderInvalid(config)) {
            console.log('auth is invalid!', config.headers[AUTHZ], isAuthHeaderInvalid(config), shouldAttemptTokenRefresh());

            // check to see if we have a refresh token
            if (shouldAttemptTokenRefresh()) {
              var $http = $injector.get('$http');
              var OAuthKeys = $injector.get('OAuthKeys');

              var theRetry = RetryQueue.pushRetryFn('unauthorized', function retryRequest() {
                $log.debug('LI: Retry Request fn executing calling: ', config.url);
                var latestAccessToken = Session.getAccessToken();
                $log.debug('LI: Access token retrieved from in retryRequest:', latestAccessToken);
                config.headers[AUTHZ] = 'Bearer ' + latestAccessToken;

                console.log('-- REQUEST: retrying', config.url);

                return config;
              });

              var tt = Session.getAccessToken();
              if (!_.isUndefined(tt) && tt !== 'undefined') {
                $log.debug('LI: Session.getAccessToken() is defined: ', tt);
                Session.setAccessToken(undefined);
                  var refToken = Session.getRefreshToken();
                  $log.debug('LI: header defined but request failed. Going to try with refresh_token: ', refToken);
                  return OAuthKeys.getKeys().then(function (keyData) {
                    var data = {
                      refresh_token: Session.getRefreshToken(),
                      grant_type: 'refresh_token',
                      client_id: keyData.uid,
                      client_secret: keyData.secret
                    };

                    return $http.post(ServerUrls.current.railsApi + 'oauth/token', data)
                      .then(function (resp) {
                        $log.debug('LI: Got token response back: ', resp);
                        if (resp && resp.data && resp.data.access_token && !_.isUndefined(resp.data.access_token) && !_.isNull(resp.data.access_token)) {
                          Session.setAccessToken(resp.data.access_token);
                        }

                        if (resp && resp.data && resp.data.refresh_token && !_.isUndefined(resp.data.refresh_token) && !_.isNull(resp.data.refresh_token)) {
                          Session.setRefreshToken(resp.data.refresh_token);
                        }

                        $rootScope.$broadcast('loginStateChanged', {state: true});
                        EventTrackingService.addEvent('reauth_success', {
                          uuid: Session.getSessionId(),
                          user_id: Session.getCurrentUserId()
                        });

                        var newToken = Session.getAccessToken();
                        $log.debug('LI: refresh_token went through. retry with new access_token: ', newToken);
                        RetryQueue.retryAll();
                        return theRetry;
                      }, function () {
                        //if refresh token fails let's clear all information and go to login
                        $log.debug('LI: Refresh_token attempt failed. Unset headers & tokens');
                        EventTrackingService.addEvent('reauth_failure', {
                          old_uuid: Session.getSessionId(),
                          user_id: Session.getCurrentUserId()
                        });
                        clearSession();
                        RetryQueue.cancelAll();
                        $rootScope.goToLogin(true);
                        //$location.path('/login');

                        //return $q.reject(originalResponse);
                      });
                  });
              } else {
                if (!Session.getRefreshToken()) {
                  $log.debug('LI: Refresh_token also null/undefined. Unset headers & tokens');
                  EventTrackingService.addEvent('both_tokens_undefined', {
                    old_uuid: Session.getSessionId(),
                    user_id: Session.getCurrentUserId()
                  });
                  clearSession();
                  RetryQueue.cancelAll();
                  $rootScope.goToLogin(true);
                  toastr.error('Sorry! Please login again as your session expired.', 'Error');
                } else {
                  $log.debug('LI: AccessToken was undefined. Put the request onto the retry queue');
                  return theRetry;
                }
              }

            } else {
              // there was no refresh token
              console.log('no refresh token');
              clearSession();
              RetryQueue.cancelAll();
              $rootScope.goToLogin(true);
            }
          }

          return config;
        },
        requestError: function(rejection) {
          console.log('requestError', rejection);
          return $q.reject(rejection);
        },
        response: function(response) {
          return response;
        },
        responseError: function(rejection) {
          console.log('responseError', rejection);

          var $http = $injector.get('$http');
          var OAuthKeys = $injector.get('OAuthKeys');
          var SAErrorHandler = $injector.get('SAErrorHandler');
          var toastr = $injector.get('toastr');

          // need to figure out if we can recover
          if (shouldAttemptRecovery(rejection)) {
            if (shouldAttemptTokenRefresh()) {

              var theRetry = RetryQueue.pushRetryFn('unauthorized', function retryRequest() {
                $log.debug('LI: Retry Request fn executing calling: ', rejection.config.url);
                var latestAccessToken = Session.getAccessToken();
                $log.debug('LI: Access token retrieved from in retryRequest:', latestAccessToken);
                rejection.config.headers[AUTHZ] = 'Bearer ' + latestAccessToken;
                //$log.debug('rejection: ', rejection);

                console.log('-- RESPONSE: retrying', rejection.config.url);

                return $http(rejection.config);
              });

              var tt = Session.getAccessToken();
              if (!_.isUndefined(tt) && tt !== 'undefined') {
                $log.debug('LI: Session.getAccessToken() is defined: ', tt);
                Session.setAccessToken(undefined);
                var refToken = Session.getRefreshToken();
                $log.debug('LI: header defined but request failed. Going to try with refresh_token: ', refToken);
                return OAuthKeys.getKeys().then(function (keyData) {
                  var data = {
                    refresh_token: Session.getRefreshToken(),
                    grant_type: 'refresh_token',
                    client_id: keyData.uid,
                    client_secret: keyData.secret
                  };

                  return $http.post(ServerUrls.current.railsApi + 'oauth/token', data)
                    .then(function (resp) {
                      $log.debug('LI: Got token response back: ', resp);
                      if (resp && resp.data && resp.data.access_token && !_.isUndefined(resp.data.access_token) && !_.isNull(resp.data.access_token)) {
                        Session.setAccessToken(resp.data.access_token);
                      }

                      if (resp && resp.data && resp.data.refresh_token && !_.isUndefined(resp.data.refresh_token) && !_.isNull(resp.data.refresh_token)) {
                        Session.setRefreshToken(resp.data.refresh_token);
                      }

                      $rootScope.$broadcast('loginStateChanged', {state: true});
                      EventTrackingService.addEvent('reauth_success', {
                        uuid: Session.getSessionId(),
                        user_id: Session.getCurrentUserId()
                      });

                      var newToken = Session.getAccessToken();
                      $log.debug('LI: refresh_token went through. retry with new access_token: ', newToken);
                      RetryQueue.retryAll();
                      return theRetry;
                    }, function () {
                      //if refresh token fails let's clear all information and go to login
                      $log.debug('LI: Refresh_token attempt failed. Unset headers & tokens');
                      EventTrackingService.addEvent('reauth_failure', {
                        old_uuid: Session.getSessionId(),
                        user_id: Session.getCurrentUserId()
                      });
                      clearSession();
                      RetryQueue.cancelAll();
                      $rootScope.goToLogin(true);
                      //$location.path('/login');

                      return $q.reject(rejection);
                    });
                });
              } else {
                if (!Session.getRefreshToken()) {
                  $log.debug('LI: Refresh_token also null/undefined. Unset headers & tokens');
                  EventTrackingService.addEvent('both_tokens_undefined', {
                    old_uuid: Session.getSessionId(),
                    user_id: Session.getCurrentUserId()
                  });
                  clearSession();
                  RetryQueue.cancelAll();
                  $rootScope.goToLogin(true);
                  toastr.error('Sorry! We experienced an issue and need you to login again.', 'Error');
                  return $q.reject(rejection);
                } else {
                  $log.debug('LI: AccessToken was undefined. Put the request onto the retry queue');
                  return theRetry;
                }
              }


            } else {
              // there was no refresh token
              console.log('no refresh token');
              clearSession();
              RetryQueue.cancelAll();
              $rootScope.goToLogin(true);
              return $q.reject(rejection);
            }
          } else if (!isAnalyticsCaptureRequest(rejection.config) && (rejection.status === 0 || rejection.status === -1)) { // NO INTERNET CONNECTION
            $log.debug('got a 0');
            toastr.error('Seems like you lost your internet connection. Refresh the page whenever it\'s back.', 'Error');
            return $q.reject(rejection);

          } else if (rejection.status === 400) { // BAD REQUEST
            $log.debug('got a 400');
            return $q.reject(rejection);

          } else if (rejection.status === 403) { // FORBIDDEN
            $log.debug('got a 403');
            $log.debug('rejection: ', rejection);

            if (rejection.data && rejection.data.error_code) {
              if (rejection.data.error_code === SAErrorHandler.RequestOutsideOfPermissionsCode) {
                $log.debug('RequestOutsideOfPermissionsCode');

                var didRegister = $rootScope.registerForbiddenRequest(rejection);

                if (!didRegister) {
                  // if we weren't in a page transition, put up a flash message
                  toastr.error('Sorry. You don\'t have permission to do that. Are you an \'active\' employee?', 'Error');
                }

              } else if (rejection.data.error_code === SAErrorHandler.AccessDeniedCode) {
                $log.debug('AccessDeniedCode');

                var didRegister = $rootScope.registerForbiddenRequest(rejection);

                if (!didRegister) {
                  // if we weren't in a page transition, put up a flash message
                  toastr.error('Sorry. You don\'t have permission to do that.  Are you an \'active\' employee?', 'Error');
                }
              } else {
                $log.debug('error_code:', rejection.data);
              }
            } else {
              $log.debug('did NOT have error_code');
            }

            return $q.reject(rejection);

          } else if (rejection.status === 500) { // Internal Server Error
            $log.debug('got a 500');
            return $q.reject(rejection);

          } else if (rejection.status === 422) {
            $log.debug('got a 422');
            return $q.reject(rejection);

          } else if (rejection.status === 429) {
            $log.debug('got a 429');
            return $q.reject(rejection);

          } else {
            if (!isAnalyticsCaptureRequest(rejection.config)) {
              $log.debug('LI: else condition, clearing session and cancelling all in queue');
              clearSession();
              RetryQueue.cancelAll();
              //$location.path('/login');
              $rootScope.goToLogin(true);
              if (!$rootScope.logoutCalled) {
                toastr.error('Sorry! We experienced an issue and need you to login again.', 'Error');
              }
            }
            return $q.reject(rejection);
          }

        }
      };
  }])
  .config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('loginInterceptor');
  }]);
